import React, { useEffect, useState } from 'react'
import DataTable, { defaultThemes } from 'react-data-table-component'
import { HighlisghtVideosApi } from '../../Services/allApi';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    maxHeight: '90%',
    overflowY: 'auto' // Make the Box scrollable
};
function HighlightVideosList() {
    const [token, setToken] = useState()
    const [videoData, setVideoData] = useState([])
    const [isEdited, setIsEdited] = useState(1)
    useEffect(() => {
        setToken(sessionStorage.getItem('access_token'))
        if (token) {
            GetVideoData()
        }
        else {
            console.log("token fetching failed");
        }
    }, [token, isEdited])

    const GetVideoData = async () => {
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const result = await HighlisghtVideosApi()
        console.log(result);
        setVideoData(result?.data)
    }

    // table style
    const customStyles = {
        rows: {
            style: {
                '&:nth-child(odd)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '40px',
                },
                '&:nth-child(even)': {
                    backgroundColor: 'white',
                    minHeight: '40px'
                },
                '&:nth-child(1)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '40px'
                },
                '&:nth-child(2)': {
                    backgroundColor: 'white',
                    minHeight: '40px'
                },
            },
        },
        header: {
            style: {
                minHeight: '4px',
            },
        },
        headRow: {
            style: {
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default,
                backgroundColor: '#18A0FB',
                color: 'white',
                height: '50px',
            },
        },
        headCells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
        cells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
    };
    // table data
    const columns = [
        {
            name: 'Sl No',
            selector: row => row.slno,
            sortable: true,
        },
        {
            name: 'Id',
            selector: row => row.id,
            sortable: true,
        },
        {
            name: 'Mapping Id',
            selector: row => row.Mapid,
            sortable: true,
        },
        {
            name: 'Seq no',
            selector: row => row.seqno,
            sortable: true,
        },
        {
            name: 'KLA',
            selector: row => row.KLA,
            sortable: true,
        },
        {
            name: 'Session',
            selector: row => row.Session,
            sortable: true,
        },
        {
            name: 'Event',
            selector: row => row.Event,
            sortable: true,
        },
        {
            name: 'Member',
            selector: row => row.Member,
            sortable: true,
        },
        {
            name: 'Subject',
            selector: row => row.title,
            sortable: true,
        },
        {
            name: 'Date',
            selector: row => row.Date,
            sortable: true,
        },
    ];
    var data = []
    // iterate data
    videoData?.length > 0 && videoData?.map((item, index) => {
        const slno = index + 1;
        const id = item.video_id;
        const Mapid = item.mapping_id;
        const seqno = item.video_sequence_no;
        const KLA = item.kla;
        const Session = item.video_session;
        const Event = item.video_event;
        const Member = item.video_member;
        const title = item.video_subject;
        const Date = item.video_upload_date;
        const ParentId = item.parent_video;
        const PartOrder = item.part_order;
        const UploadedBy = item.uploaded_by;
        const CreatedAt = item.created_at?.slice(0, 10);
        const UpldatedAt = item.updated_at?.slice(0, 10);

        const newObj = { id, seqno, slno, title, KLA, Session, Event, Member, Date, ParentId, PartOrder, Mapid, UploadedBy, CreatedAt, UpldatedAt };
        data.push(newObj);
    })
    return (
        <>
            <div className=' border-gray-500 p-5 rounded '>
                <DataTable
                    title=""
                    columns={columns}
                    data={data}
                    customStyles={customStyles}
                    pagination
                    dense
                    highlightOnHover
                    selectableRowsHighlight
                    paginationPerPage={25} // Initial page size
                    paginationRowsPerPageOptions={[25, 50, 100, 150, 200]} // Options for users to change page size
                />
            </div>
        </>
    )
}

export default HighlightVideosList